var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12 -325) translate(-4) translate(2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f6102a",
    d: "M14.228 7.382c-.5-2.536-2.728-4.44-5.404-4.44-2.125 0-3.971 1.205-4.89 2.97C1.72 6.147 0 8.022 0 10.294c0 2.434 1.978 4.412 4.412 4.412h9.559c2.029 0 3.676-1.647 3.676-3.677 0-1.94-1.507-3.514-3.42-3.647z",
    transform: "translate(14 325) translate(1.176 1.176)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherError);
export default __webpack_public_path__ + "static/media/weather-error.460c803470cdea53788fa5f392585d28.svg";
export { ForwardRef as ReactComponent };